import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnchorComponent } from './anchor/anchor.component';

@NgModule({
  exports: [AnchorComponent],
  imports: [CommonModule, AnchorComponent],
})
export class AnchorModule {}
